exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-appointment .appointment-calendar {\n  margin: 0 auto;\n}\n.add-appointment .view_content_markdownmg h1.center {\n  font-size: 24px;\n  font-family: \"nunitobold\", sans-serif;\n  line-height: 32px;\n  margin-bottom: 16px;\n}\n.add-appointment .view_content_markdownmg p.center {\n  font-size: 16px;\n  margin-bottom: 24px;\n}", ""]);

// exports
